// extracted by mini-css-extract-plugin
export var avatarContainer = "_hf-0";
export var avatarTypingWave = "_hf-i";
export var gray = "_hf-f";
export var green = "_hf-c";
export var icon = "_hf-9";
export var image = "_hf-1";
export var lg = "_hf-6";
export var md = "_hf-5";
export var presenceDot = "_hf-b";
export var red = "_hf-d";
export var sm = "_hf-4";
export var status = "_hf-a";
export var typingDot = "_hf-h";
export var typingPill = "_hf-g";
export var xl = "_hf-7";
export var xs = "_hf-3";
export var xxl = "_hf-8";
export var xxs = "_hf-2";
export var yellow = "_hf-e";